import { withHydrate } from '@relay/react/hooks';
import useBodyScrollLock from '@hooks/useBodyScrollLock';

// import { ButtonIcon, ButtonText } from '@stories/Elements/Forms/Button/Button.styles';
// import Loader from '@stories/Elements/Loaders/Loader/Loader';
import Cross from '@img/icons/icon-cross.svg';
import Button from '@stories/Elements/Forms/Buttons/Button';
import { ButtonIcon } from '@stories/Elements/Forms/Buttons/Button.styles';
import Loader from '@stories/Elements/Misc/Loader/Loader.hybrid';
import Cookies from 'js-cookie';
import * as React from 'react';
import { createGlobalStyle } from 'styled-components';
import S from './CookiePopup.styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const OneTrustCSSOverrides = /*#__PURE__*/createGlobalStyle(["\n  #onetrust-banner-sdk, .onetrust-pc-dark-filter {\n    display: none !important;\n  }\n"]);
const POLLING_INTERVAL = 100;
const CookiePopup = props => {
  const [isOpen, setIsOpen] = React.useState(undefined);
  const scrollableRef = useBodyScrollLock(!!isOpen);
  const loadOneTrust = async () => {
    const promise = new Promise(resolve => {
      if (!props.oneTrustScriptID) {
        return resolve(undefined);
      }
      if (window.OneTrust) {
        return resolve(window.OneTrust);
      }
      const script = document.createElement('script');
      script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
      script.type = 'text/javascript';
      script.charset = 'UTF-8';
      script.setAttribute('data-domain-script', props.oneTrustScriptID);
      script.addEventListener('load', () => {
        const handle = window.setInterval(() => {
          if (window.OneTrust) {
            const element = document.querySelector('#onetrust-consent-sdk');
            if (element) {
              console.log('one trust loaded!', window.OneTrust);
              window.clearInterval(handle);
              return resolve(window.OneTrust);
            }
          }
        }, POLLING_INTERVAL);
      });
      document.head.appendChild(script);
    });
    return promise;
  };
  const clearButtonStates = () => {
    const acceptAllButton = document.querySelector('#cookie-onetrust-accept-all');
    const showInfoButton = document.querySelector('#cookie-onetrust-show-info');
    const acceptNecessaryButton = document.querySelector('#cookie-onetrust-only-necessary');
    if (acceptAllButton) {
      const iconElement = acceptAllButton.querySelector('i');
      if (iconElement !== null) {
        iconElement.style.display = 'none';
      }
      acceptAllButton.removeAttribute('data-icon');
      acceptAllButton.removeAttribute('data-icon-visibility');
    }
    if (showInfoButton) {
      const iconElement = showInfoButton.querySelector('i');
      if (iconElement !== null) {
        iconElement.style.display = 'none';
      }
      showInfoButton.removeAttribute('data-icon');
      showInfoButton.removeAttribute('data-icon-visibility');
    }
    if (acceptNecessaryButton) {
      const iconElement = acceptNecessaryButton.querySelector('i');
      if (iconElement !== null) {
        iconElement.style.display = 'none';
      }
      acceptNecessaryButton.removeAttribute('data-icon');
      acceptNecessaryButton.removeAttribute('data-icon-visibility');
    }
  };
  const ShowInfoDisplay = async () => {
    const oneTrust = await loadOneTrust();
    oneTrust?.ToggleInfoDisplay();
    clearButtonStates();
  };
  const AcceptAll = async () => {
    const oneTrust = await loadOneTrust();
    oneTrust?.AllowAll();
    clearButtonStates();
  };
  const AcceptNecessary = async () => {
    const oneTrust = await loadOneTrust();
    oneTrust?.Close();
    clearButtonStates();
  };
  const processUnhandledEvents = () => {
    if (!window.OneTrustUnhandledEvent || window.OneTrustUnhandledEvent.length === 0) {
      return;
    }

    // Handle the unhandled event which may be set before react hydrates
    switch (window.OneTrustUnhandledEvent) {
      case 'show-info':
        {
          ShowInfoDisplay();
          break;
        }
      case 'accept-all':
        {
          AcceptAll();
          break;
        }
      case 'only-necessary':
        {
          AcceptNecessary();
          break;
        }
    }
    delete window.OneTrustUnhandledEvent;
  };
  React.useEffect(() => {
    // Handle closing our modal when the one trust has been closed / accepted
    const handle = window.setInterval(async () => {
      if (window.OneTrust && window.OneTrust.IsAlertBoxClosed !== undefined && window.OneTrust.IsAlertBoxClosed()) {
        setIsOpen(false);
        window.clearInterval(handle);
      }
    }, POLLING_INTERVAL);
  }, []);

  // Load onetrust on pageload if the cookie has already been accepted
  React.useEffect(() => {
    const oneTrustPopupClosed = !!Cookies.get('OptanonAlertBoxClosed');
    if (!oneTrustPopupClosed) {
      return;
    }
    loadOneTrust();
  }, []);

  // Load onetrust on load if the buttons have been clicked prior to react loading
  React.useEffect(() => {
    processUnhandledEvents();
  }, []);
  const secondaryButtonTheme = props.forceAllGreenButtons ? 'green' : 'grey-outline';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(OneTrustCSSOverrides, {}), /*#__PURE__*/_jsx(S.Container, {
      id: "onetrust-cookie-popup",
      style: {
        display: isOpen !== undefined ? isOpen ? 'flex' : 'none' : undefined
      },
      children: /*#__PURE__*/_jsxs(S.Modal, {
        ref: scrollableRef,
        onMouseEnter: loadOneTrust,
        "data-buttons": props.onlyUseNecessaryCookiesText ? 3 : 2,
        children: [props.showClose ? /*#__PURE__*/_jsx(S.Close, {
          id: "cookie-onetrust-close",
          onClick: AcceptNecessary,
          children: /*#__PURE__*/_jsx(Cross, {})
        }) : null, /*#__PURE__*/_jsxs(S.ModalInner, {
          children: [/*#__PURE__*/_jsx(S.Title, {
            children: props.title
          }), /*#__PURE__*/_jsx(S.Description, {
            dangerouslySetInnerHTML: {
              __html: props.description
            }
          }), /*#__PURE__*/_jsxs(S.Buttons, {
            children: [/*#__PURE__*/_jsxs(Button, {
              id: "cookie-onetrust-show-info",
              theme: secondaryButtonTheme,
              size: "small",
              icon: "none",
              onClick: ShowInfoDisplay,
              children: [/*#__PURE__*/_jsx("span", {
                "data-cta-text": true,
                children: props.openCookieSettingsText
              }), /*#__PURE__*/_jsx(ButtonIcon, {
                style: {
                  display: 'none'
                },
                children: /*#__PURE__*/_jsx(Loader, {})
              })]
            }), props.onlyUseNecessaryCookiesText ? /*#__PURE__*/_jsxs(Button, {
              id: "cookie-onetrust-only-necessary",
              theme: secondaryButtonTheme,
              size: "small",
              icon: "none",
              onClick: AcceptNecessary,
              children: [/*#__PURE__*/_jsx("span", {
                "data-cta-text": true,
                children: props.onlyUseNecessaryCookiesText
              }), /*#__PURE__*/_jsx(ButtonIcon, {
                style: {
                  display: 'none'
                },
                children: /*#__PURE__*/_jsx(Loader, {})
              })]
            }) : null, /*#__PURE__*/_jsxs(Button, {
              id: "cookie-onetrust-accept-all",
              theme: "green",
              size: "small",
              icon: "none",
              onClick: AcceptAll,
              children: [/*#__PURE__*/_jsx("span", {
                "data-cta-text": true,
                children: props.acceptAllCookiesText
              }), /*#__PURE__*/_jsx(ButtonIcon, {
                style: {
                  display: 'none'
                },
                children: /*#__PURE__*/_jsx(Loader, {})
              })]
            }), /*#__PURE__*/_jsx("script", {
              dangerouslySetInnerHTML: {
                __html: `
                (() => {
                  const acceptAllButton = document.querySelector('#cookie-onetrust-accept-all');
                  const showInfoButton = document.querySelector('#cookie-onetrust-show-info');
                  const acceptNecessaryButton = document.querySelector('#cookie-onetrust-only-necessary');
                  const closeButton = document.querySelector('#cookie-onetrust-close');

                  function addClickToButton(button, id, dataAttributes) {
                    if (button === null) {
                      return;
                    }

                    button.addEventListener('click', (e) => handleClick(e, id, dataAttributes));
                  }

                  function clearButton(button) {
                    if (button === null) {
                      return;
                    }

                    const iconElement = button.querySelector('i');

                    if (iconElement !== null) {
                      iconElement.style.display = 'none';
                    }

                    button.removeAttribute('data-icon');
                    button.removeAttribute('data-icon-placement');
                    button.removeAttribute('data-icon-visibility');
                  }

                  function handleClick(event, id, dataAttributes) {
                    clearButton(acceptAllButton);
                    clearButton(showInfoButton);
                    clearButton(acceptNecessaryButton);

                    // Show i icon
                    const iconElement = event.currentTarget.querySelector('i');

                    if (iconElement !== null) {
                      iconElement.style.display = '';
                    }

                    if (dataAttributes) {
                      event.currentTarget.setAttribute('data-icon', 'loader');
                      event.currentTarget.setAttribute('data-icon-placement', 'after');
                      event.currentTarget.setAttribute('data-icon-visibility', 'always');
                    }

                    window.OneTrustUnhandledEvent = id;
                  }

                  addClickToButton(acceptAllButton, 'accept-all', true);
                  addClickToButton(showInfoButton, 'show-info', true);
                  addClickToButton(acceptNecessaryButton, 'only-necessary', true);
                  addClickToButton(closeButton, 'only-necessary', false);
                })();
            `
              }
            })]
          })]
        })]
      })
    })]
  });
};
export const clientConfig = {
  hydrate: 'always'
};
export default withHydrate(CookiePopup, 'CookiePopup', 'hybrid');
